<template>
<v-container fill-height fluid>
	<v-layout align-center justify-center>
		<v-img class="dashboardLogo" :aspect-ratio="736/312" max-width="50%" :src="require('../../assets/logo.png')"/>
	</v-layout>
</v-container>
</template>
<script>
export default {
	mounted () {
		this.$store.commit('core/appToolbar/resetToolbar')
		this.$store.commit('core/appToolbar/setHeader', 'Dashboard')
	}
}
</script>
<style>
.dashboardLogo {
	filter: grayscale(80%);
	opacity: 0.15;
}
</style>
